import { HTTPError } from "ky";
import type { ViewsV2ErrorBody } from "./types";

/** Frozen-copy shown whenever a Views V2 write fails with SERVICE_NOT_CUT_OVER. */
export const VIEWS_V2_FROZEN_MESSAGE =
  "Saving views is temporarily disabled during the platform upgrade. Your current screen is unaffected.";

export async function parseViewsV2Error(err: unknown): Promise<ViewsV2ErrorBody | null> {
  if (!(err instanceof HTTPError)) return null;
  try {
    const body = (await err.response.clone().json()) as ViewsV2ErrorBody;
    return body && typeof body.code === "string" ? body : null;
  } catch {
    return null;
  }
}
